export default function flyerForm() {
    const form = document.querySelector(".fh-flyer-form");
    if (!form) return;

    const button = form.querySelector(".fh-flyer-submit");
    const message = form.querySelector(".fh-flyer-message");
    const emailInput = form.querySelector(".fh-flyer-input");
    const webhookUrl = form.dataset.webhookUrl;

    form.addEventListener("submit", async (event) => {
        event.preventDefault();

        if (!form.checkValidity()) {
            form.reportValidity();
            return;
        }

        button.disabled = true;
        button.style.opacity = "0.7";
        message.textContent = "";

        try {
            await fetch(webhookUrl, {
                method: "POST",
                mode: "no-cors",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ email: emailInput.value }),
            });

            button.classList.add("fh-flyer-success");
            message.textContent = "Danke! Wir melden uns in Kürze per E-Mail.";
            form.reset();

            setTimeout(() => {
                button.classList.remove("fh-flyer-success");
                button.disabled = false;
                button.style.opacity = "1";
            }, 2200);
        } catch (err) {
            message.textContent =
                "Da ist etwas schiefgelaufen. Bitte versuche es erneut.";
            button.disabled = false;
            button.style.opacity = "1";
        }
    });
}
